import {Compiler, Component, SystemJsNgModuleLoader} from "@angular/core";

import {BaseCreateAppV2ComponentInput} from "./base-create-app-details.component";
import {BaseCreateAppImportV2ComponentInput} from "./base-create-app-import.component";
import {
    BaseCreateAppChooserV2ComponentOutput,
    BaseCreateAppChooserV2ComponentInput,
} from "./base-create-app-chooser.component";
import {
    TCIApplicationCreateOption,
    TCITenantAppType,
    TCITenantAppTypeMetaData,
    TCITenantSelectorType
} from "@tci/common";
import {
    ITCICreateAppComponentInput,
    ITCIUploadComponentDroppedFilesOutput,
    ITCIUploadComponentInput
} from "../../../ng-tenant/tci-tenant-components";
import {TCITenantLoaderComponent} from "../../../ng-tenant/tci-tenant-component";
import {AbstractTciTenantComponentLoader} from "../../../ng-tenant/tci-tenant-component-loader.component";
import {TCITenantRemoteServices} from "../../../ng-tenant/tci-tenant-remote-services";
import {TciTenantService} from "../../../ng-tenant/tci-tenant.service";
import {TciTenantModelService} from "../../../ng-tenant/tci-tenant.model";

// Extended class for the Tenant Component Loader (App Create Detail)
export class TCITenantCreateAppV2ComponentInput extends BaseCreateAppV2ComponentInput implements ITCICreateAppComponentInput {
    constructor(type: TCITenantAppType,
                private createOption: TCIApplicationCreateOption,
                public metaData: TCITenantAppTypeMetaData,
                public isRecommended: boolean = false
    ) {
        super(type, createOption);
        this.tenantAppType = type;
        this.componentSelector = TCITenantSelectorType.TCI_CREATE_APP;
    }
}

@TCITenantLoaderComponent({
    isdynamic: true
})
@Component({
    selector: "ng-tenant-details-cmp",
    template: "<template #dynamic></template><div class='is-recommended' *ngIf='this.input.isRecommended'>TIBCO recommended for {{this.input.metaData.label}}</div>"
})
export class TCICreateTenantAppDetailDynLoaderV2Component
    extends AbstractTciTenantComponentLoader<any, TCITenantCreateAppV2ComponentInput, any> {
    constructor(
        loader: SystemJsNgModuleLoader,
        compiler: Compiler,
        tenantRemoteServices: TCITenantRemoteServices,
        tenantSvc: TciTenantService,
        tenantModelSvc: TciTenantModelService
    ) {
        super(loader, compiler, tenantRemoteServices, tenantSvc, tenantModelSvc);
    }
}

// Extended class for the Tenant Component Loader (App Import)
export class TCITenantCreateAppImportV2ComponentInput extends BaseCreateAppImportV2ComponentInput implements ITCIUploadComponentInput {
    constructor(type: TCITenantAppType, private createOption: TCIApplicationCreateOption) {
        super(type, createOption);
        this.tenantAppType = type;
        this.componentSelector = TCITenantSelectorType.TCI_APP_CREATE_FILE_UPLOAD;
    }
}

@TCITenantLoaderComponent({
    isdynamic: true
})
@Component({
    selector: "ng-tenant-import-cmp",
    template: "<template #dynamic></template>"
})
export class TCICreateTenantAppImportDynLoaderV2Component
    // tslint:disable-next-line:max-line-length
    extends AbstractTciTenantComponentLoader<any, TCITenantCreateAppImportV2ComponentInput, ITCIUploadComponentDroppedFilesOutput | boolean> {
    constructor(
        loader: SystemJsNgModuleLoader,
        compiler: Compiler,
        tenantRemoteServices: TCITenantRemoteServices,
        tenantSvc: TciTenantService,
        tenantModelSvc: TciTenantModelService
    ) {
        super(loader, compiler, tenantRemoteServices, tenantSvc, tenantModelSvc);
    }
}

// Extended class for the Tenant Component Loader (API Chooser)
export class TCITenantCreateAppChooserV2ComponentInput extends BaseCreateAppChooserV2ComponentInput implements ITCIUploadComponentInput {
    constructor(type: TCITenantAppType, private createOption: TCIApplicationCreateOption) {
        super(type, createOption);
        this.tenantAppType = type;
        this.componentSelector = TCITenantSelectorType.TCI_APP_CREATE_API_SPEC;
    }
}

@TCITenantLoaderComponent({
    isdynamic: true
})
@Component({
    selector: "ng-tenant-api-chooser-cmp",
    template: "<template #dynamic></template>"
})
export class TCICreateTenantAppChooserDynLoaderV2Component
    extends AbstractTciTenantComponentLoader<any, TCITenantCreateAppChooserV2ComponentInput, BaseCreateAppChooserV2ComponentOutput<number>> {
    constructor(
        loader: SystemJsNgModuleLoader,
        compiler: Compiler,
        tenantRemoteServices: TCITenantRemoteServices,
        tenantSvc: TciTenantService,
        tenantModelSvc: TciTenantModelService
    ) {
        super(loader, compiler, tenantRemoteServices, tenantSvc, tenantModelSvc);
    }
}

export class TCITenantCreateAppGraphQLImportV2ComponentInput extends BaseCreateAppImportV2ComponentInput implements ITCIUploadComponentInput {
    constructor(type: TCITenantAppType, private createOption: TCIApplicationCreateOption) {
        super(type, createOption);
        this.tenantAppType = type;
        this.componentSelector = TCITenantSelectorType.TCI_APP_CREATE_GRAPHQL_SCHEMA;
    }
}

@TCITenantLoaderComponent({
    isdynamic: true
})
@Component({
    selector: "ng-tenant-graphql-schema-cmp",
    template: "<template #dynamic></template>"
})
export class TCICreateTenantAppGraphQLImportDynLoaderV2Component
    extends AbstractTciTenantComponentLoader<any, TCITenantCreateAppImportV2ComponentInput, ITCIUploadComponentDroppedFilesOutput | boolean> {
    constructor(
        loader: SystemJsNgModuleLoader,
        compiler: Compiler,
        tenantRemoteServices: TCITenantRemoteServices,
        tenantSvc: TciTenantService,
        tenantModelSvc: TciTenantModelService
    ) {
        super(loader, compiler, tenantRemoteServices, tenantSvc, tenantModelSvc);
    }
}


export class TCITenantCreateAppMarketplaceV2ComponentInput extends BaseCreateAppImportV2ComponentInput implements ITCIUploadComponentInput {
    constructor(type: TCITenantAppType, private createOption: TCIApplicationCreateOption, public mkTags: string[]) {
        super(type, createOption);
        this.tenantAppType = type;
        this.componentSelector = TCITenantSelectorType.TCI_APP_CREATE_MARKETPLACE;
    }
}

@TCITenantLoaderComponent({
    isdynamic: true
})
@Component({
    selector: "ng-tenant-marketplace-mini",
    template: "<template #dynamic></template>"
})
export class TCICreateTenantAppMarketplaceDynLoaderV2Component
    extends AbstractTciTenantComponentLoader<any, TCITenantCreateAppMarketplaceV2ComponentInput, any> {
    constructor(
        loader: SystemJsNgModuleLoader,
        compiler: Compiler,
        tenantRemoteServices: TCITenantRemoteServices,
        tenantSvc: TciTenantService,
        tenantModelSvc: TciTenantModelService
    ) {
        super(loader, compiler, tenantRemoteServices, tenantSvc, tenantModelSvc);
    }
}
